export default {
    login: '/api/v1/login',
    logout: '/api/v1/logOut',
    checkLoginSession: '/api/v1/checkLoginSession',
    getSession: '/api/v1/getSession',
    getPlayerBalance: '/api/v1/getPlayerBalance',
    getBetsHistory: '/api/v1/getBetsHistory',
    getPlayerTransactions: '/api/v1/getPlayerTransactions',
    getAllPlayerTransactions: '/api/v1/wallet/getWalletTransactions',
    getAllHistoryPlayerTransactions: '/api/v1/wallet/requestHistoricalWalletTransactions',
    checkDepositEligibility: '/api/v1/checkDepositEligibility',
    checkWithdrawalEligibility: '/api/v1/checkWithdrawalEligibility',
    createOnlineDeposit: '/api/v1/createOnlineDeposit',
    createOnlineWithdrawal: '/api/v1/createOnlineWithdrawal',
    createOnlineTransaction: '/api/v1/createOnlineTransaction',
    createBankTransferWithdrawal: '/api/v1/createBankWithdrawal',
    cancelWithdrawal: '/api/v1/cancelWithdrawal',
    getPlayerSettings: '/api/v1/getPlayerSettings',
    updatePlayerSettings: '/api/v1/updatePlayerSetting',
    uploadDocumentVerification: '/api/v1/uploadDocumentVerification',
    getClubs: '/api/v1/getClubs',
    registrationSecondStep: '/api/v1/registrationSecondStep',
    forgotPassword: '/api/v1/forgotPassword',
    updatePassword: '/api/v1/updatePassword',
    changeForgottenPassword: '/api/v1/changeForgottenPassword',
    getAllGames: '/api/v1/getAllGames',
    getPlayerShortcutGames: '/api/v1/getPlayerShortcutGames',
    togglePlayerShortcutGames: '/api/v1/togglePlayerShortcutGames',
    gamingPlay: '/api/v1/gaming/play',
    getPopupMessages: '/api/v1/getPopupMessages',
    launchGame: '/api/v1/casino/launchGame',
    getBanners: '/api/v1/getBanners',
    getPlayerDetails: '/api/v1/getPlayerDetails',
    messageAction: '/api/v1/messageAction',
    returnSiteParams: '/api/v1/returnSiteParams',
    getCountries: '/api/v1/telephonePrefixes',
    update: '/api/v1/update',
    updatePrivacyConsent: '/api/v1/updatePrivacyConsent',
    validateRegistrationData: '/api/v1/validateRegistrationData',
    apiVersion: '/api/v1',
    getGameHistory: '/api/v1/getGameHistory',
    getJackpotData: '/api/v1/getJackpotData',
    getJackpotDataEgyptQuest: '/api/v1/getJackpotDataEgyptQuest',
    resendSmsCode: '/api/v1/resendSmsCode',
    validateSmsCode: '/api/v1/validateSmsCode',
    sendActivationEmail: 'api/v1/sendActivationEmail',
    getPlayerLimits: '/api/v2/getPlayerLimits',
    setPlayerLimits: '/api/v1/setPlayerLimits',
    cancelPlayerLimit: '/api/v1/cancelPlayerLimit',
    timeOutPlayer: '/api/v1/TimeOutPlayer',
    selfExcludePlayer: '/api/v1/selfExcludePlayer',
    closeAccount: '/api/v1/CloseAccount',
    closeAccountMfa: '/api/v1/closeAccountMFA',
    getPlayerBonuses: '/api/v3/getPlayerBonuses',
    getAvailableBonuses: '/api/v1/getAvailableBonuses',
    getLottoFavorites: 'api/v1/getLotoFavorites',
    setLottoFavorites: 'api/v1/setLotoFavorites',
    shopWithdrawal: 'api/v1/shopWithdrawal',
    bonusOptIn: '/api/v1/bonusOptIn',
    bonusOptOut: '/api/v1/bonusOptOut',
    casinoPrefix: '/api/v1/casino',
    walletBreakdown: '/api/v3/getPlayerBalance',
    fetchBetGeniusStreamData: '#', // TODO betler?
    getBetEligibility: '#',
    updateCustomParams: '#',
    identityData: '/api/v1/identityData',
    sendPlayerLoginNotification: '#',
    loginPlayerAlternativeChannel: '#',
    getLoginData: '#',
    getWelcomeBonusEligibility: '#',
    getListOfPromotions: '/api/v1/getPlayerCampaigns',
    getListOfPlayerPromotions: '/api/v1/getPlayerCampaigns',
    playerLicencePreferences: '/api/v1/playerLicence',
    getIdentityProviderUrl: 'api/v1/getIdentityProviderUrl',
    getKYCMojeIdResponse: '#',
    getVerificationUrl: 'api/v1/verificationUrl',
    getFaceVerificationUrl: 'api/v1/verificationUrl/faceid',
    getMfaStatus: 'api/v1/mfa/status',
    mfaFinalize: 'api/v1/mfa/finalize',
    createQuickDeposit: 'api/v1/createQuickDeposit',
    setLocale: 'api/v1/setLocale',
    getRegulatorData: 'api/v1/getRegulatorData',
    getLoginHistory: 'api/v1/getLoginHistory',
    getKycDetails: 'api/v1/getKycDetails',
    promotionOptIn: '/api/v1/updatePlayerCampaign',
    bankRegistrationUrl: '/api/v1/wallet/bankRegistration',
    verifyMfaCode: '#',
    sendMfaCode: '#',
    getSessionStats: '/api/v1/sessionStats',
    completeKycReverification: '#',
};

export const serviceProps = {
    launchDarklyUserKeyVariable: 'userUuid',
} as const;
